module.exports = __webpack_public_path__ + "ipetbooking/admin/img/face-cream.603679e8.svg";